import React, { useEffect, useState } from 'react';
import { cn } from '../../lib/utils';
import { formatSponsorText, resolveSponsorLogoUrl } from '../../lib/sponsor';

interface CampaignSponsorLogoProps {
  sponsorLogoUrl?: string | null;
  sponsorNames?: string[];
  /** `default`: full width. `compact`: full width on mobile, capped on md+ (dashboard). `prominent`: capped height (quiz/leaderboard). */
  size?: 'default' | 'compact' | 'prominent';
  /** @deprecated Use parent layout for alignment. */
  align?: 'center' | 'left';
  className?: string;
}

const wrapperClassBySize = {
  default: 'w-full',
  compact: 'w-full md:w-auto md:max-w-[18rem]',
  prominent: 'w-full',
} as const;

const imageClassBySize = {
  default: 'block w-full h-auto object-contain',
  compact: 'block w-full h-auto object-contain md:max-h-32',
  prominent: 'block w-full h-auto max-h-28 object-contain',
} as const;

export function CampaignSponsorLogo({
  sponsorLogoUrl,
  sponsorNames = [],
  size = 'default',
  className,
}: CampaignSponsorLogoProps) {
  const [logoFailed, setLogoFailed] = useState(false);
  const resolvedUrl = resolveSponsorLogoUrl(sponsorLogoUrl);
  const sponsorText = formatSponsorText(sponsorNames);

  useEffect(() => {
    setLogoFailed(false);
  }, [resolvedUrl]);

  if (!resolvedUrl || logoFailed) return null;

  return (
    <div className={cn(wrapperClassBySize[size], className)}>
      <img
        src={resolvedUrl}
        alt={sponsorText ? `Sponsored by ${sponsorText}` : 'Campaign sponsor logo'}
        className={imageClassBySize[size]}
        onError={() => setLogoFailed(true)}
      />
    </div>
  );
}
